// -----------------
// STATE - This defines the type of data maintained in the Redux store.
import { OrderHead, OrderRows } from '../apiClient/client';

export class ApiOrderObject extends OrderHead {
     
}

export class ApiOrderRowObject extends OrderRows {

}

/*
export class ApiOrderObject {
    orderNumber: string | undefined ;
    customer: string | undefined ;
    territory: string | undefined ;
    orderReference: string | undefined ;
    orderDate: Date | undefined ;
    purchaseOrder: string | undefined ;
    shippingName: string | undefined ;
    shippingAddress: string | undefined ;
    shippingCity: string | undefined ;
    shippingState: string | undefined ;
    shippingPostalCode: string | undefined ;
    shippingPhone: string | undefined ;
    shippingFax: string | undefined ;
    estimatedShipDate: Date | undefined ;
    orderId: string | undefined ;
    orderRows: ApiOrderRowObject[] | undefined;

    constructor(
        orderNumber: string | undefined ,
        customer: string | undefined ,
        territory: string | undefined ,
        orderReference: string | undefined ,
        orderDate: Date | undefined ,
        purchaseOrder: string | undefined ,
        shippingName: string | undefined ,
        shippingAddress: string | undefined ,
        shippingCity: string | undefined ,
        shippingState: string | undefined ,
        shippingPostalCode: string | undefined ,
        shippingPhone: string | undefined ,
        shippingFax: string | undefined ,
        estimatedShipDate: Date | undefined ,
        orderId: string | undefined,
        orderRows: ApiOrderRowObject[] | undefined 
    ) {
        this.orderNumber = orderNumber;
        this.customer = customer;
        this.territory = territory;
        this.orderReference = orderReference;
        this.orderDate = orderDate;
        this.purchaseOrder = purchaseOrder;
        this.shippingName = shippingName;
        this.shippingAddress = shippingAddress;
        this.shippingCity = shippingCity;
        this.shippingState = shippingState;
        this.shippingPostalCode = shippingPostalCode;
        this.shippingPhone = shippingPhone;
        this.shippingFax = shippingFax;
        this.estimatedShipDate = estimatedShipDate;
        this.orderId = orderId;
        this.orderRows = orderRows;
    }
}

export class ApiOrderRowObject {
    lineNumber: number | undefined ;
    itemNumber: string | undefined ;
    description: string | undefined ;

    constructor(
    lineNumber: number | undefined ,
    itemNumber: string | undefined ,
    description: string | undefined 
    ) {
        this.lineNumber = lineNumber;
        this.itemNumber = itemNumber;
        this.description = description;
    }
}
*/
export class ApiOrderState {
    orders: ApiOrderObject[];
    order: ApiOrderObject | undefined;
    loading: boolean;
}


// WEBPACK FOOTER //
// ./src/data/order/orderModels.ts